import { render, staticRenderFns } from "./ProRePassPage.vue?vue&type=template&id=0847eb71"
import script from "./ProRePassPage.vue?vue&type=script&lang=js"
export * from "./ProRePassPage.vue?vue&type=script&lang=js"
import style0 from "./ProRePassPage.vue?vue&type=style&index=0&id=0847eb71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports